<template>
  <v-btn :href="to" color="primary" class="main-btn">{{ label }}</v-btn>
</template>
<script>
export default {
  name: 'PrimaryButton',
  props: {
    label: { type: String },
    to: { type: String },
  },
  data() {
    return {}
  },
}
</script>
<style scoped lang="scss">
::v-deep.v-btn {
  font-size: 1.25rem !important;
  font-weight: $font-weight-medium !important;
}
</style>
